module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAIZJREFUWAlj3HXq4n+GAQRMA2g32GoWZAf8Z/j/FZlPKzYjAyMX0GxGkPlwBwDj4Ze7mQEPrSxFNnfnqYvXgbZrgMQGPApGHTAaAqMhMBoCoyEwGgKjITAaAqMhMBoCoyEwGgLwnhGwp8K68+SF88g9GBqyFWFmwx0AFGAEAgOYBL3oAU8DAG+QEB5dCt/4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unsubscribe.png
// module id = 0nlU
// module chunks = 12